var map = {
	"./admin/account.json": 19501,
	"./admin/addresses.json": 76127,
	"./admin/admin.json": 18553,
	"./admin/algos.json": 92544,
	"./admin/bank.json": 99095,
	"./admin/bds.json": 76056,
	"./admin/boxes.json": 94089,
	"./admin/common.json": 42192,
	"./admin/consultation.json": 48417,
	"./admin/dongle.json": 31575,
	"./admin/emr.json": 76298,
	"./admin/eyes.json": 38181,
	"./admin/keyboard.json": 9650,
	"./admin/login.json": 67391,
	"./admin/logs.json": 43970,
	"./admin/nav.json": 20990,
	"./admin/notifications.json": 35614,
	"./admin/opto.json": 88725,
	"./admin/organization.json": 27450,
	"./admin/patient.json": 99127,
	"./admin/practionner.json": 27301,
	"./admin/role.json": 18140,
	"./admin/settings.json": 56804,
	"./admin/shop.json": 94232,
	"./admin/stats.json": 28209,
	"./admin/subscriptions.json": 40255,
	"./admin/table.json": 81913,
	"./admin/test_cases.json": 55348,
	"./admin/tips.json": 37583,
	"./admin/validations.json": 66768,
	"./app_strings.json": 29686,
	"./client/account_client.json": 82079,
	"./client/common_client.json": 6147,
	"./client/console.json": 28986,
	"./client/consultation_client.json": 69418,
	"./client/eyes.json": 49265,
	"./client/nav_client.json": 95655,
	"./client/patient_client.json": 97368,
	"./client/pdf.json": 60746,
	"./client/shop_client.json": 78116,
	"./client/stats_client.json": 98932,
	"./client/validations.json": 39566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76330;